import React from 'react';
import { NavigateListenerWrap } from '../router-wrap/NavigateListener';
import { useUpComm } from '../basic/UpComm';
import { ProfileEventTypes } from '../screens/Profile/ProfileData';

export interface UCNavigateListenerProps<T extends typeof useUpComm = any> {
  useUpComm: T;
}

export const UCNavigateListener: React.FC<UCNavigateListenerProps> = props => {
  const { children, useUpComm } = props;
  const upComm = useUpComm();

  return (
    <NavigateListenerWrap
      targetWindow={window}
      onLoad={({ location }) => {
        upComm.sendMsg({
          type: ProfileEventTypes.pageLoad,
          data: {
            location: location
          }
        });
      }}
      onUnload={({ location }) => {
        upComm.sendMsg({
          type: ProfileEventTypes.pageUnload,
          data: {
            location: location
          }
        });
      }}
    >
      {children}
    </NavigateListenerWrap>
  );
};
